import { Type } from 'class-transformer';
import { ResourceUUIDVersionIdentifier, UUID } from 'src/app/common/model/resource-id-version-identifier';

export class LineDirectionCountersResetsDto {
    readonly id: UUID;
    readonly line: string;
    readonly carrierId: number;
    readonly direction: string;
    readonly resets: Reset[];
    @Type(() => Date)
    readonly modified: Date;
    readonly version: number;

    getVersionedId(): ResourceUUIDVersionIdentifier {
        return new ResourceUUIDVersionIdentifier(this.id, this.version);
    }

}


export class Reset {
    constructor(
        public readonly stopCode: string,
        public readonly sequenceNumber: number
    ) { }

    equals(other: Reset): boolean {
        return this.stopCode === other.stopCode && this.sequenceNumber === other.sequenceNumber;
    }
}

